import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home, LoginRegister, PasswordReset, ChangePassword, Plans, PitchProfessional, ActionPlanView, PitchResultView, PmvValidation, PmvResultView, OportunidadesMap, OppResultView, UnderConstruction } from "./pages/AllPages";
import { AuthProvider } from './contexts/AuthContext';
import Header from "./components/Header";
import NotFound from './components/NotFound';
import Footer from "./components/Footer";

function App() {
  return (
    <AuthProvider>
      <>
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/login/' element={<LoginRegister />} />
          <Route path='/under-construction/' element={<UnderConstruction />} />
          <Route path='/plans/' element={<Plans />} />
          <Route path='/plans/pitch/' element={<PitchProfessional />} />
          <Route path='/plans/:slug/action-plan' element={<ActionPlanView />} />
          <Route path='/plans/pitch/:slug/result' element={<PitchResultView />} />
          <Route path='/plans/pmv/' element={<PmvValidation />} />
          <Route path='/plans/pmv/:slug/result' element={<PmvResultView />} />
          <Route path='/plans/opp/' element={<OportunidadesMap />} />
          <Route path='/plans/opp/:slug/result' element={<OppResultView />} />
          <Route path='/forgot-password/' element={<PasswordReset />} />
          <Route path='/change-password/' element={<ChangePassword />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        <Footer />
        <div id="popup-root"></div>
      </>
    </AuthProvider>
  );
}

export default App;